import { render, staticRenderFns } from "./SLAPopoverCard.vue?vue&type=template&id=0003a492&"
import script from "./SLAPopoverCard.vue?vue&type=script&setup=true&lang=js&"
export * from "./SLAPopoverCard.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0003a492')) {
      api.createRecord('0003a492', component.options)
    } else {
      api.reload('0003a492', component.options)
    }
    module.hot.accept("./SLAPopoverCard.vue?vue&type=template&id=0003a492&", function () {
      api.rerender('0003a492', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/components/SLAPopoverCard.vue"
export default component.exports